module.exports = __webpack_public_path__ + "img/pcb_anjian.prt.9778715c.jpg";